module.exports = __webpack_public_path__ + "img/yxh2.608d2a99.gif";